<template>
  <div>
    <header
      class="site-header"
      :class="{ scrolled: isScrolled }"
    >
      <div class="header-inner">
        <router-link
          :to="{ name: logoPath }"
          class="logo"
        >
          <img
            class="logo-icon"
            src="../../assets/logo-circle.svg"
            alt="Guiders"
          />
          <span class="logo-text">Guiders</span>
        </router-link>

        <!-- Signed out: just the logo. Signed in: the account circle and
             its menu (same as the homepage header), on every screen size -->
        <AccountMenu v-if="loggedIn" />
      </div>
    </header>
  </div>
</template>

<script>
import { isSignedIn, dashboardRouteFor } from "../../utils/accountHome";

import AccountMenu from "./AccountMenu.vue";

import { HelpersMixin } from "../../mixins";

export default {
  name: "SiteHeader",

  mixins: [HelpersMixin],

  components: {
    AccountMenu
  },

  props: ["isSignedIn"],

  data() {
    return {
      search: "",
      isScrolled: false
    };
  },

  computed: {
    // Signed in = there's a user in the store (set at login, cleared at
    // sign out). Before, this depended on extra checks that could show the
    // visitor menu, with no "Sign out", to a signed-in person.
    loggedIn() {
      return isSignedIn(this.$store.state.users);
    },

    dashboardRoute() {
      return dashboardRouteFor(this.$store.state.users);
    },

    // Signed in: the logo goes to your dashboard (not the public home page)
    logoPath() {
      return this.dashboardRoute || "home";
    }
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    search(value) {
      this.$router.push({
        name: "discover",
        query: {
          search: value
        }
      });
    }

  },

  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    }
  }
};
</script>

<style scoped>
:root {
  --color-primary: #f05a45;
  --color-primary-dark: #d97706;
  --color-primary-light: #f05a451c;
  --color-secondary: #1f2c33;
  --color-text: #45505f;
  --color-heading: #1f2c33;
  --color-bg: #ffffff;
  --color-bg-alt: #f7fafd;
  --color-border: #e7ecee;
  --color-white: #ffffff;
  --color-black: #000000;
  --radius: 8px;
  --radius-lg: 16px;
  --container: 1200px;
  --font-body: "Inter", sans-serif;
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 12px 40px rgba(0, 0, 0, 0.12);
  --transition: 0.3s ease;
}
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  border-bottom: 1px solid transparent;
  padding: 0 20px;
}

.site-header.scrolled {
  background: var(--color-white, #ffffff);
  box-shadow: none;
  border-bottom-color: #e7ecee;
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
}

/* =========================
   LOGO
========================= */

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 1.125rem;
  color: #1f2c33;
}

.logo-icon {
  height: 2rem;
}


</style>